import * as XLSX from 'xlsx-js-style';

const totalSalaryReadSheets = ['市政分公司', '铁路分公司', '桥梁分公司', '隧道分公司', '道路分公司', '设计分公司']; // 只关注这几个sheet
const focusData = [
  {
    headerName: '姓名',
    headerKey: '',
  },
  {
    headerName: '部门',
    headerKey: '',
  },
  {
    headerName: '应发工资',
    headerKey: '',
  },
  {
    headerName: '实际出勤总天数',
    headerKey: '',
  }
];

const readTotalSalary = (file, readCallback) => {
  const reader = new FileReader();
  reader.onload = (e) => {
    const data = new Uint8Array(e.target.result);
    const workbook = XLSX.read(data, { type: 'array' });
    let headers = [];
    let rows = [];
    const sheets = workbook.SheetNames;
    sheets.forEach((sheet, index) => {
      if (totalSalaryReadSheets.indexOf(sheet) >= 0) {
        const jsonData = XLSX.utils.sheet_to_json(workbook.Sheets[sheet], { header: 2 });
        if (jsonData.length > 0){
          if (headers.length === 0) { // 没有表头是先填充表头数据
            const currentHeaders = jsonData[0];
            Object.keys(currentHeaders).forEach((key) => {
              const value = currentHeaders[key];
              const findHeader = focusData.find(item => item.headerName === value.replace(/\n/g, ""));
              if (findHeader) {
                findHeader.headerKey = key;
                headers.push(findHeader);
              }
            });
          }
          jsonData.forEach((row, rowIndex) => {
            if (rowIndex === 1 || rowIndex === 0){ 
              return; // 表头有合并，第一行和第二行行数据不管
            }
            if (rowIndex > (jsonData.length - 5)) { // 表尾有合计，后四行行数据不管
              return;
            }
            const rowData = {};
            headers.forEach((header) => {
              rowData[header.headerName] = row[header.headerKey] || '';
            });
            if (!rowData['姓名']) {
              return;
            }
            rows.push({ ...rowData, key: `${index}-${rowIndex}` });
          });
        }
      }
    });
    readCallback(headers.map(item => item.headerName), rows);
  };
  reader.readAsArrayBuffer(file);
};

const readOther = (file, readCallback) => {
  const reader = new FileReader();
  reader.onload = (e) => {
    const data = new Uint8Array(e.target.result);
    const workbook = XLSX.read(data, { type: 'array' });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    let headers = [];
    let rows = [];
    if (jsonData.length > 0) {
      headers = jsonData[0];
      rows = jsonData.slice(1).map((row, rowIndex) => {
        const rowData = {};
        headers.forEach((header, colIndex) => {
          rowData[header] = row[colIndex] || '';
        });
        return { ...rowData, key: rowIndex };
      });
    }
    readCallback(headers, rows);
  };
  reader.readAsArrayBuffer(file);
}

export {
  readTotalSalary,
  readOther
}